import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import ChevronDownGray from '../../assets/icons/ChevronDownGray.svg';

const ContainerDropdown = styled.div`
  position: relative;
  width: ${({ width }) => width};
`;

const CollapsedDropdown = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  font-family: 'Hind';
  font-style: normal;
  font-weight: ${({ insideHeader }) => (insideHeader ? 500 : 400)};
  font-size: 14px;
  line-height: 22px;
  color: ${({ disabled }) => (disabled ? select('midLightGray') : 'auto')};
  background-color: ${({ disabled }) => select(disabled ? 'lightGray' : 'white')};
  border-radius: 8px;
  border: 1px solid
    ${({ disabled, insideHeader }) => {
      if (disabled) return select('lightGray');
      if (insideHeader) return select('transparent');
      return select('midDarkGray');
    }};
  border-color: ${({ active, withoutBorder, insideHeader }) =>
    active && !withoutBorder && !insideHeader && getColor('primary')};
  padding: ${({ placeHolder }) => (placeHolder ? '0 13px' : '0')};
  display: flex;
  justify-content: ${({ insideHeader }) => (insideHeader ? 'start' : 'space-between')};
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  ${({ isStatisticsByPosting, device }) => {
    if (isStatisticsByPosting && device === 'mobile') {
      return css`
        width: fit-content;
        margin: -8px 0 0 -10px;
      `;
    }
    if (isStatisticsByPosting && device === 'tablet') {
      return css`
        width: fit-content;
      `;
    }
    return null;
  }}
`;

const ElementBox = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ insideHeader }) => (insideHeader ? 6 : 12)}px;
  margin-left: 6px;
`;

const Icon = styled.img`
  display: block;
  margin-left: 3px;
  opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
`;

const TextSelected = styled.div`
  min-width: 100px;
  margin-top: 4px;
  text-align: start;
`;

const PlaceHolderStyled = styled.div`
  min-width: 100px;
  text-align: start;
  color: ${select('midLightGray')};
`;

const Chevron = styled.button`
  width: ${({ insideHeader }) => (insideHeader ? 18 : 23)}px;
  height: ${({ insideHeader }) => (insideHeader ? 18 : 23)}px;
  background-image: ${`url(${ChevronDownGray})`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  opacity: ${({ disabled }) => (disabled ? '0.2' : '1')};
  transform: ${({ active }) => `rotateX(${active ? '180deg' : '0deg'})`};
  transition: all 0.4s ease;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  margin-right: 6px;
  margin-top: ${({ insideHeader }) => (insideHeader ? 4 : 0)}px;
`;

const OpenDropdown = styled.div`
  position: absolute;
  top: ${({ insideHeader }) => (insideHeader ? 28 : 52)}px;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: ${({ width }) => width};
  margin-top: 8px;
  padding-top: 10px;
  border-radius: 8px;
  border: 1px solid ${select('midDarkGray')};
  background-color: ${select('white')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.4s ease;
  z-index: 3;
`;

const ListItems = styled.div`
  height: 40px;
  padding-top: 10px;
  padding-left: 14px;
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
  > label {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  :hover {
    font-weight: 600;
    line-height: 130%;
    background-color: ${select('lightGray')};
  }
  :last-of-type {
    border-radius: 0 0 8px 8px;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      color: ${select('midLightGray')};
      :hover {
        font-weight: 400;
        line-height: 22px;
        background-color: transparent;
      }
    `}
`;
const ContainerDatePicker = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 16px 14px;
  position: relative;
  ${({ device }) =>
    device === 'tablet' &&
    css`
      justify-content: flex-start;
      gap: 20px;
    `}
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const CTA = styled.button`
  height: 40px;
  width: 100%;
  border-radius: 8px;
  color: white;
  background-color: ${getColor('primary')};
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  letter-spacing: 0em;
  text-align: center;
  margin: 16px 16px;
  cursor: pointer;
  :hover {
    background-color: ${getColor('secondary')};
  }
`;

export {
  ContainerDropdown,
  CollapsedDropdown,
  ElementBox,
  Icon,
  TextSelected,
  PlaceHolderStyled,
  Chevron,
  OpenDropdown,
  ListItems,
  ContainerDatePicker,
  ButtonContainer,
  CTA
};
